module.exports = __webpack_public_path__ + "img/sang-wook-kim-the-danced-all-night.5816c3c.jpg";